export const skills = [
    {
      skillKey: "skills.javascript",
      percentage: 100,
    },
    {
      skillKey: "skills.typescript",
      percentage: 100,
    },
    {
      skillKey: "skills.nodejs",
      percentage: 100,
    },
    {
      skillKey: "skills.expressjs",
      percentage: 100,
    },
    {
      skillKey: "skills.nestjs",
      percentage: 99,
    },
    {
      skillKey: "skills.reactJs",
      percentage: 95,
    },
    {
      skillKey: "skills.reactHooks",
      percentage: 90,
    },
    {
      skillKey: "skills.reactNative",
      percentage: 80,
    },
    {
      skillKey: "skills.gdscript",
      percentage: 85,
    },
    {
      skillKey: "skills.n8n",
      percentage: 80,
    },
    {
      skillKey: "skills.langchain",
      percentage: 85,
    },
    {
      skillKey: "skills.copyPasting",
      percentage: 100,
    },
];
